export default function (): any {
  return Promise.resolve().then((): any => {
    const localData = localStorage.getItem("appUser");
    if (!localData) return;
    return JSON.parse(localData);
  });
}
